<script lang="ts" setup>

import {useSynchroStore} from "@/stores/synchro.store.ts";
import {Source} from "@/domain/type/source.type.ts";
import router from "@/router/router.ts";
import {RouteEnum} from "@/router/RouteEnum.ts";
import {SynchroType} from "@/domain/type/synchro.type.ts";

const props = defineProps<{
  originSource: Source
}>()
const synchroStore = useSynchroStore()

function canCreate() {
  const sourceIsOk = [Source.EVA, Source.AMMON].includes(props.originSource);
  const typeIsOk = synchroStore.type === SynchroType.COMPANIES
  return sourceIsOk && typeIsOk
}

function redirect() {
  if (canCreate()) {
    router.push({
      name: RouteEnum.Create,
      params: {
        'target': props.originSource,
        'type': synchroStore.type
      }
    })
  }
}

</script>

<template>
  <div class="px-5">
    <v-btn :disabled="!canCreate()" class="createBtn" color="white" icon="mdi-plus" rounded="true" size="xx-small" variant="tonal" @click="redirect"/>
  </div>
</template>

<style scoped>

</style>
